import * as THREE from 'three'
export default class motor{
    constructor(offsetPos, parentPos, parentQuat){
        this.maxThrust = 1;
        this.coefLift = .02;        
        this.throttle = 0;        
        this.offsetPos = offsetPos;
        this.throttleSteps = 100;
        this.parentPos = parentPos;
        this.parentQuat = parentQuat
        this.updateForce();
    }


    throttleUp(){
        this.throttle++;
        if(this.throttle>this.throttleSteps)
            this.throttle=this.throttleSteps;
        console.log("throttle up", this.throttle);
        this.updateForce();
    }
    throttleDown(){
        this.throttle--;
        if(this.throttle<0)
            this.throttle = 0;
            console.log("throttle down", this.throttle);
        this.updateForce();
    }

    setThrottle(base, t){        
        this.baseThrottle = base;
        this.throttle = t;
        this.updateForce();
    }
    getThrottle(){        
        return this.throttle;
    }

    updateForce(){
        this.force = new THREE.Vector3(0,1,0).applyQuaternion( this.parentQuat ).normalize().multiplyScalar(this.getThrust()).multiplyScalar(this.coefLift);        
    }
    getImpulseForce(){
        return this.force;
    }
    getImpulsePosition(){
        //return new THREE.Vector3().copy(this.parentPos).add(this.offsetPos)
        return new THREE.Vector3().copy(this.offsetPos).applyQuaternion(this.parentQuat).add(this.parentPos);
    }

    getThrust(){
        let perc = (this.baseThrottle +this.throttle)/this.throttleSteps
        let t= this.maxThrust * perc;
        return t;
    }
}